import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ContentWrap from "../../components/layout/ContentWrap";
import {Button} from "react-bootstrap";
import Styles from './TagView.module.scss'
import {navigate} from "../../helper/HistoryHelper";
import {tagStore} from "../../store/TagStore";
import {MdRemoveRedEye, MdSubtitles} from "react-icons/md";
import {FaUser} from "react-icons/fa";
import {IoIosArrowForward} from "react-icons/io";

@observer
class CategoryView extends Component {

    constructor(props) {
        super(props);
        this.state={
            keyword : ''
        }

    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    renderLink({title, link}){
        return (
            <div className={`d-flex flex-grow-1`}>
                <Button variant={"outline-light"} className={`flex-grow-1`}
                        onClick={()=>{
                            navigate(link)
                        }}
                >
                    <div className={`d-flex justify-content-between`}>
                        {title}
                        <div className={`d-flex align-items-center`}>
                            <IoIosArrowForward/>
                        </div>
                    </div>
                </Button>
            </div>
        )
    }

    render() {
        let store = actorTagStore;
        return (
            <ContentWrap>

                <div className={Styles.Content}
                     ref={store.scrollRef}
                     onScroll={store.onScrollHandler}
                >
                    <div className={`pb-3`}>
                        <h2>바로가기</h2>
                    </div>
                    <div className={`d-flex flex-wrap gap-3`}>
                        {this.renderLink({
                            title:
                                <div className={`d-flex align-items-center`}>
                                    <MdRemoveRedEye className={`me-2`}/> 미시청
                                </div>,
                            link: '/main/home'
                        })}
                        {this.renderLink({
                            title:
                                <div className={`d-flex align-items-center`}>
                                    <FaUser className={`me-2`}/> 배우
                                </div>,
                            link: '/main/tag/actor'
                        })}
                        {this.renderLink({
                            title:
                                <div className={`d-flex align-items-center`}>
                                    <MdSubtitles className={`me-2`}/> ChatGPT 자막
                                </div>,
                            link: '/main/tag/concept/286'
                        })}
                    </div>
                </div>
            </ContentWrap>
        );
    }
}

CategoryView.propTypes = {};

export default CategoryView;
